module.exports = __webpack_public_path__ + "img/202310_05.b82e4c54.jpg";